import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=669845f9&scoped=true&lang=pug"
import script from "./ServiceSection.vue?vue&type=script&lang=ts"
export * from "./ServiceSection.vue?vue&type=script&lang=ts"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=669845f9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669845f9",
  null
  
)

export default component.exports